import * as dateFns from 'date-fns';

// make any adjustments to the date range
export default function sanitizeDateRange(date) {
  let start = date?.start || dateFns.startOfYear(new Date());
  let end = date?.end || dateFns.endOfYear(new Date());

  // if the start and end date are in the same month, set the end date to the end of the month
  if (dateFns.format(start, 'yyyy-MM') === dateFns.format(end, 'yyyy-MM')) {
    start = dateFns.startOfYear(start);
    end = dateFns.endOfYear(end);
  }

  return { start, end };
}
